<template>
  <div>
    <div
      class="comment-item"
      v-for="comment in comments"
      :key="comment.id + 'comment'"
    >
      <div
        class="icon-action"
        v-if="$user.doctor.id === comment.doctor_id"
      >
        <div class="dropdown">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <path
              d="M14.5488 8.289C14.5488 7.464 13.8738 6.789 13.0488 6.789C12.2238 6.789 11.5488 7.464 11.5488 8.289C11.5488 9.114 12.2238 9.789 13.0488 9.789C13.8738 9.789 14.5488 9.114 14.5488 8.289ZM14.5488 17.289C14.5488 16.464 13.8738 15.789 13.0488 15.789C12.2238 15.789 11.5488 16.464 11.5488 17.289C11.5488 18.114 12.2238 18.789 13.0488 18.789C13.8738 18.789 14.5488 18.114 14.5488 17.289ZM14.5488 12.789C14.5488 11.964 13.8738 11.289 13.0488 11.289C12.2238 11.289 11.5488 11.964 11.5488 12.789C11.5488 13.614 12.2238 14.289 13.0488 14.289C13.8738 14.289 14.5488 13.614 14.5488 12.789Z"
              fill="#6D88A3"
            />
          </svg>
          <div
            class="dropdown-menu"
            aria-labelledby="dropdownMenuButton"
          >
            <a
              class="dropdown-item"
              href="javascript:;"
              @click="onEdit(comment)"
            >Chỉnh sửa</a>
            <a
              class="dropdown-item"
              href="javascript:;"
              @click="deleteIndicationComments(comment.id)"
            >Xóa</a>
          </div>
        </div>
      </div>
      <div class="avatar-side">
        <span
          v-if="
            comment.doctor && comment.doctor.user && comment.doctor.user.avatar
          "
          class="avatar avatar-rounded mr-2"
          :style="
            'background-image: url(' +
            getImageURL(comment.doctor.user.avatar) +
            ')'
          "
        ></span>
        <span
          v-else
          class="avatar avatar-sm avatar-rounded mr-2"
        >
          {{
            comment.doctor && comment.doctor.name
              ? comment.doctor.name.charAt(0)
              : ""
          }}
        </span>
      </div>
      <div class="content-side">
        <div class="d-flex justify-content-between align-items-center">
          <p class="fs-14 fw-500 txt-grey-900 mb-0 max-line-1">
            {{
              comment.doctor && comment.doctor.name ? comment.doctor.name : ""
            }}
          </p>
          <p class="fs-11 fw-400 txt-grey-700 mb-0 max-line-1">
            {{
              comment.created_at
                ? formatDateCmt(comment.created_at)
                : ""
            }}
          </p>
        </div>
        <p class="fs-14 fw-500 txt-pri mb-2">
          {{
            comment.doctor && comment.doctor.chuc_vu
              ? comment.doctor.chuc_vu
              : ""
          }}
        </p>
        <div
          class="file-list"
          v-if="comment.files && comment.files.length"
        >
          <div
            class="file-item"
            v-for="file in comment.files"
            :key="file.id + 'file-ne'"
            @click="onOpenFile(file)"
          >
            <div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                v-if="file.type === 1"
                class="mr-2"
              >
                <g clip-path="url(#clip0_24814_125783)">
                  <path
                    d="M6.14703 0H14.1772L20.9748 7.09195V20.8779C20.9748 22.6023 19.5771 24 17.8526 24H6.14703C4.42256 24 3.0249 22.6023 3.0249 20.8779V3.12212C3.0249 1.39769 4.42256 0 6.14703 0V0Z"
                    fill="#0263D1"
                  />
                  <path
                    opacity="0.302"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.1675 0V7.0337H20.9747L14.1675 0Z"
                    fill="white"
                  />
                  <path
                    d="M6.95996 16.6667V12.7879H9.60769V13.5492H7.89746V14.3447H9.43913V15.1079H7.89746V16.6667H6.95996Z"
                    fill="white"
                  />
                  <path
                    d="M11.0173 12.7879V16.6667H10.0798V12.7879H11.0173Z"
                    fill="white"
                  />
                  <path
                    d="M11.6058 16.6667V12.7879H12.5433V15.9053H14.1569V16.6667H11.6058Z"
                    fill="white"
                  />
                  <path
                    d="M14.6423 16.6667V12.7879H17.3468V13.5492H15.5798V14.3447H17.2085V15.1079H15.5798V15.9053H17.3468V16.6667H14.6423Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_24814_125783">
                    <rect
                      width="24"
                      height="24"
                      fill="white"
                    />
                  </clipPath>
                </defs>
              </svg>

              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-2"
                v-if="file.type === 2"
              >
                <path
                  d="M6.66672 11.9601L5.48672 13.1068C5.1773 13.4162 4.75764 13.5901 4.32005 13.5901C3.88247 13.5901 3.46281 13.4162 3.15339 13.1068C2.84397 12.7974 2.67014 12.3777 2.67014 11.9401C2.67014 11.5026 2.84397 11.0829 3.15339 10.7735L6.18005 7.74014C6.47713 7.4421 6.8774 7.26966 7.29806 7.25849C7.71873 7.24732 8.12758 7.39828 8.44005 7.68014L8.52005 7.74681C8.64647 7.87057 8.81688 7.93905 8.99379 7.93718C9.1707 7.9353 9.33962 7.86323 9.46339 7.73681C9.58716 7.61039 9.65563 7.43998 9.65376 7.26307C9.65188 7.08616 9.57981 6.91724 9.45339 6.79347C9.41576 6.74482 9.37571 6.6981 9.33339 6.65347C8.76429 6.15835 8.02828 5.89804 7.27443 5.92527C6.52059 5.9525 5.80528 6.26524 5.27339 6.80014L2.20672 9.83347C1.68562 10.4007 1.4038 11.1473 1.4201 11.9173C1.43641 12.6874 1.74957 13.4214 2.29421 13.966C2.83884 14.5106 3.57283 14.8238 4.34289 14.8401C5.11294 14.8564 5.85952 14.5746 6.42672 14.0535L7.58005 12.9268C7.69393 12.8026 7.75653 12.6398 7.75526 12.4713C7.75399 12.3028 7.68894 12.141 7.57319 12.0185C7.45745 11.896 7.29961 11.8219 7.13143 11.811C6.96325 11.8002 6.79721 11.8535 6.66672 11.9601ZM13.7934 2.46681C13.2326 1.90948 12.474 1.59666 11.6834 1.59666C10.8927 1.59666 10.1342 1.90948 9.57339 2.46681L8.42005 3.59347C8.30618 3.71771 8.24358 3.88046 8.24485 4.04898C8.24612 4.21751 8.31117 4.3793 8.42691 4.5018C8.54265 4.6243 8.7005 4.69841 8.86868 4.70924C9.03686 4.72006 9.2029 4.66679 9.33339 4.56014L10.4867 3.41347C10.7961 3.10405 11.2158 2.93022 11.6534 2.93022C12.091 2.93022 12.5106 3.10405 12.8201 3.41347C13.1295 3.72289 13.3033 4.14255 13.3033 4.58014C13.3033 5.01772 13.1295 5.43739 12.8201 5.74681L9.79339 8.78014C9.49631 9.07818 9.09604 9.25062 8.67538 9.26179C8.25472 9.27296 7.84586 9.122 7.53339 8.84014L7.45339 8.77347C7.32697 8.6497 7.15656 8.58123 6.97965 8.5831C6.80274 8.58498 6.63382 8.65705 6.51005 8.78347C6.38629 8.90989 6.31781 9.0803 6.31968 9.25721C6.32156 9.43412 6.39363 9.60304 6.52005 9.72681C6.56848 9.77633 6.61967 9.82307 6.67339 9.86681C7.24317 10.3604 7.97887 10.6198 8.73225 10.5926C9.48564 10.5653 10.2007 10.2536 10.7334 9.72014L13.7667 6.68681C14.3276 6.12952 14.6452 5.37296 14.6502 4.5823C14.6552 3.79165 14.3472 3.03113 13.7934 2.46681Z"
                  fill="#6E7883"
                />
              </svg>
            </div>
            <p
              class="mb-0 txt-pri fs-12 text-decoration-underline max-line-1"
              v-if="file.type === 2"
            >
              {{ file.url }}
            </p>
            <p
              class="mb-0 txt-pri fs-12 text-decoration-underline max-line-1"
              v-if="file.type === 1"
            >
              {{ file.name }}
            </p>
          </div>
        </div>
        <p
          class="pre-wrap fs-12 txt-grey-900"
          v-if="comment.id !== edit_id"
        >
          {{ comment.content }}
        </p>
        <div v-else>
          <textarea
            v-model="edit_content"
            class="form-control border"
            rows="3"
          ></textarea>
          <div class="d-flex justify-content-end my-2">
            <button
              class="btn btn-light mr-2"
              type="button"
              @click="onEdit()"
            >
              Hủy
            </button>
            <button
              class="btn bg-pri text-white"
              type="button"
              :disabled="!comment.content"
              @click="onUpdateComment"
            >
              Lưu
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white border radius-10 p-2">
      <div
        class="file-list"
        v-if="files && files.length"
      >
        <div
          class="file-item"
          v-for="(file, i) in files"
          :key="file.id + 'file-ne'"
          @click="onOpenFile(file)"
        >
          <div>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="mr-2"
            >
              <g clip-path="url(#clip0_24814_125783)">
                <path
                  d="M6.14703 0H14.1772L20.9748 7.09195V20.8779C20.9748 22.6023 19.5771 24 17.8526 24H6.14703C4.42256 24 3.0249 22.6023 3.0249 20.8779V3.12212C3.0249 1.39769 4.42256 0 6.14703 0V0Z"
                  fill="#0263D1"
                />
                <path
                  opacity="0.302"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.1675 0V7.0337H20.9747L14.1675 0Z"
                  fill="white"
                />
                <path
                  d="M6.95996 16.6667V12.7879H9.60769V13.5492H7.89746V14.3447H9.43913V15.1079H7.89746V16.6667H6.95996Z"
                  fill="white"
                />
                <path
                  d="M11.0173 12.7879V16.6667H10.0798V12.7879H11.0173Z"
                  fill="white"
                />
                <path
                  d="M11.6058 16.6667V12.7879H12.5433V15.9053H14.1569V16.6667H11.6058Z"
                  fill="white"
                />
                <path
                  d="M14.6423 16.6667V12.7879H17.3468V13.5492H15.5798V14.3447H17.2085V15.1079H15.5798V15.9053H17.3468V16.6667H14.6423Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_24814_125783">
                  <rect
                    width="24"
                    height="24"
                    fill="white"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <p class="mb-0 txt-pri fs-12 text-decoration-underline max-line-1">
            {{ file.name }}
          </p><svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="cursor-pointer"
            @click="deleteSltFile(i)"
          >
            <path
              d="M13.6053 12.0002L19.9053 5.71019C20.0936 5.52188 20.1993 5.26649 20.1993 5.00019C20.1993 4.73388 20.0936 4.47849 19.9053 4.29019C19.7169 4.10188 19.4616 3.99609 19.1953 3.99609C18.9289 3.99609 18.6736 4.10188 18.4853 4.29019L12.1953 10.5902L5.90525 4.29019C5.71695 4.10188 5.46155 3.99609 5.19525 3.99609C4.92895 3.99609 4.67356 4.10188 4.48525 4.29019C4.29695 4.47849 4.19116 4.73388 4.19116 5.00019C4.19116 5.26649 4.29695 5.52188 4.48525 5.71019L10.7853 12.0002L4.48525 18.2902C4.39152 18.3831 4.31713 18.4937 4.26636 18.6156C4.21559 18.7375 4.18945 18.8682 4.18945 19.0002C4.18945 19.1322 4.21559 19.2629 4.26636 19.3848C4.31713 19.5066 4.39152 19.6172 4.48525 19.7102C4.57821 19.8039 4.68882 19.8783 4.81067 19.9291C4.93253 19.9798 5.06324 20.006 5.19525 20.006C5.32726 20.006 5.45797 19.9798 5.57983 19.9291C5.70169 19.8783 5.81229 19.8039 5.90525 19.7102L12.1953 13.4102L18.4853 19.7102C18.5782 19.8039 18.6888 19.8783 18.8107 19.9291C18.9325 19.9798 19.0632 20.006 19.1953 20.006C19.3273 20.006 19.458 19.9798 19.5798 19.9291C19.7017 19.8783 19.8123 19.8039 19.9053 19.7102C19.999 19.6172 20.0734 19.5066 20.1241 19.3848C20.1749 19.2629 20.201 19.1322 20.201 19.0002C20.201 18.8682 20.1749 18.7375 20.1241 18.6156C20.0734 18.4937 19.999 18.3831 19.9053 18.2902L13.6053 12.0002Z"
              fill="#667085"
            />
          </svg>
        </div>
      </div>
      <div class="d-flex">
        <textarea
          v-model="content"
          class="form-control bg-white"
          placeholder="Nhập nội dung"
          rows="3"
        ></textarea>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="mx-2"
          @click="onCreateComment"
          :class="content ? 'cursor-pointer' : ''"
        >
          <path
            d="M20.5662 11.9594C20.5718 11.4485 20.2933 10.979 19.8436 10.7314L9.36277 4.94948C8.89278 4.68365 8.34042 4.71448 7.90025 5.01416C7.45148 5.3194 7.22305 6.04915 7.35041 6.57675L8.34042 10.6717C8.44149 11.0922 8.81799 11.3888 9.25008 11.3883L15.0729 11.3883C15.3716 11.3828 15.6142 11.6254 15.6086 11.924C15.6091 12.2166 15.3711 12.4547 15.0729 12.4597L9.24502 12.4547C8.81243 12.4547 8.43644 12.7498 8.33435 13.1703L7.33575 17.2759C7.21497 17.7605 7.35597 18.2462 7.69961 18.5898C7.74004 18.6302 7.78553 18.6757 7.83152 18.7106C8.27573 19.0547 8.85741 19.0997 9.35267 18.8369L19.8335 13.1773C20.2832 12.9398 20.5612 12.4698 20.5662 11.9594Z"
            :fill="content ? '#20419B' : '#989898'"
          />
          <path
            opacity="0.4"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.19619 9.02545C3.06042 8.88969 2.97628 8.7023 2.97698 8.49512C2.97698 8.08076 3.31215 7.74559 3.72652 7.74559L5.65763 7.74488C6.07128 7.74559 6.40716 8.08146 6.40787 8.49512C6.40716 8.90878 6.07128 9.24465 5.65763 9.24536L3.72652 9.24465C3.51933 9.24536 3.33195 9.16122 3.19619 9.02545ZM5.01259 12.5268C4.87682 12.391 4.79268 12.2037 4.79339 11.9965C4.79339 11.5821 5.12855 11.2469 5.54292 11.2469L7.47403 11.2462C7.88768 11.2469 8.22356 11.5828 8.22427 11.9965C8.22356 12.4101 7.88768 12.746 7.47403 12.7467L5.54292 12.746C5.33574 12.7467 5.14835 12.6626 5.01259 12.5268ZM2.66903 15.2309C2.66832 15.438 2.75247 15.6254 2.88823 15.7612C3.024 15.8969 3.21138 15.9811 3.41856 15.9804L5.34967 15.9811C5.76333 15.9804 6.0992 15.6445 6.09991 15.2309C6.0992 14.8172 5.76333 14.4813 5.34967 14.4806L3.41856 14.4813C3.0042 14.4813 2.66903 14.8165 2.66903 15.2309Z"
            :fill="content ? '#20419B' : '#989898'"
          />
        </svg>
      </div>
      <svg
        data-v-1fbe1d7c=""
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="cursor-pointer mt-2"
        @click="openPickFile"
      >
        <path
          data-v-1fbe1d7c=""
          d="M14.1304 2H6.13037C5.03037 2 4.13037 2.9 4.13037 4V20C4.13037 21.1 5.03037 22 6.13037 22H18.1304C19.2304 22 20.1304 21.1 20.1304 20V8L14.1304 2ZM18.1304 20H6.13037V4H14.1304V8H18.1304V20ZM12.1304 17C11.0304 17 10.1304 16.1 10.1304 15V9.5C10.1304 9.22 10.3504 9 10.6304 9C10.9104 9 11.1304 9.22 11.1304 9.5V15H13.1304V9.5C13.1304 8.12 12.0104 7 10.6304 7C9.25037 7 8.13037 8.12 8.13037 9.5V15C8.13037 17.21 9.92037 19 12.1304 19C14.3404 19 16.1304 17.21 16.1304 15V11H14.1304V15C14.1304 16.1 13.2304 17 12.1304 17Z"
          fill="#667085"
        ></path>
      </svg>
    </div>
    <input
      type="file"
      @change="onSelectedFile($event)"
      class="d-none"
      ref="inputFile"
      multiple
    />
  </div>
</template>

<script>
import moment from 'moment'
import appUtils from '../../utils/appUtils'
import uploadIndicationFile from '../../utils/uploadIndicationFile'
export default {
  name: 'IndicationComments',
  props: ['indication_id'],
  data () {
    return {
      comments: [],
      content: '',
      files: [],
      edit_content: [],
      edit_files: [],
      edit_id: null
    }
  },
  watch: {
    '$refresh' () {
      this.getIndicationComments()
      this.files = []
    },
    'indication_id' () {
      this.getIndicationComments()
    }
  },
  mounted () {
    this.getIndicationComments()
  },
  methods: {
    async getIndicationComments () {
      if (!this.indication_id) return
      this.comments = await this.$rf.getRequest('DoctorRequest').getIndicationComments(this.indication_id).then((r) => {
        return r.data
      })
    },
    getImageURL (avatar) {
      return appUtils.getImageURL(avatar)
    },
    formatDateCmt (date_time) {
      return date_time && moment(date_time).format('HH:mm DD/MM/YYYY')
    },
    onEdit (comment) {
      if (comment) {
        this.edit_id = comment.id
        this.edit_content = comment.content
      } else {
        this.edit_content = ''
        this.edit_id = 0
      }
    },
    async onUpdateComment () {
      if (!this.edit_id) return
      let params = {
        content: this.edit_content,
        indication_id: this.indication_id
      }
      await this.$rf.getRequest('DoctorRequest').updateIndicationComments(this.edit_id, params).then(() => {
        this.getIndicationComments()
        this.edit_id = null
        this.edit_content = ''
      })
    },
    async deleteIndicationComments (id) {
      if (!id) return
      if (!confirm('Bạn có chắc chắn muốn xóa?')) return
      await this.$rf.getRequest('DoctorRequest').deleteIndicationComments(id).then(() => {
        this.getIndicationComments()
        this.edit_id = null
        this.edit_content = ''
      })
    },
    async onCreateComment () {
      if (!this.content) return
      let params = {
        content: this.content,
        indication_id: this.indication_id
      }
      await this.$rf.getRequest('DoctorRequest').createIndicationComments(this.indication_id, params).then((r) => {
        this.getIndicationComments()
        this.content = ''
        this.uploadFile(r.data?.id)
      })
    },
    onOpenFile (file) {
      if (!file) return
      if (file.type === 1) {
        file.file_name && this.openFile(file.file_name)
      }
      if (file.type === 2 && file.url) window.open(file.url)
    },
    async openFile (name) {
      const self = this
      const params = {
        fileName: name
      }
      const header = {
        'x-api-key': '4be5160e89e681cede9a80ae6db6af7c'
      }
      await self.$rf.getRequest('AuthRequest').getLinkDownloadAwsRc(params, header, false).then((r) => {
        if (r?.data?.data) window.open(r.data.data)
      }).catch((e) => {
        self.$toast.open({
          message: 'File không tồn tại hoặc gặp lỗi trong quá trình tải xuống',
          type: 'warning'
          // all other options
        })
        console.error(e)
      })
    },
    uploadFile (comment_id) {
      if (!this.files?.length) return
      uploadIndicationFile.indicationUploadHanlder(this.indication_id, this.files, 1, comment_id)
    },
    onSelectedFile (e) {
      const files = e.target.files
      if (files) {
        for (let i = 0; i < files.length; i++) {
          this.files.push(files[i])
        }
        setTimeout(() => {
          this.$refs.inputFile.value = null
        }, 100)
      }
    },
    openPickFile () {
      this.$refs.inputFile.click()
    },
    deleteSltFile (i) {
      this.files.splice(i, 1)
    }
  }

}
</script>

<style scoped>
.comment-item {
  display: flex;
  padding: 8px;
  width: 100%;
  position: relative;
}
.comment-item .avatar-side {
  width: 56px;
}

.comment-item .content-side {
  width: calc(100% - 56px);
  padding-right: 24px;
}
.pre-wrap {
  white-space: pre;
}
.icon-action {
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
}
.file-list {
  display: flex;
  width: 100%;
  scrollbar-width: none;
  overflow: auto;
  align-items: center;
  margin-bottom: 16px;
}
.file-item {
  display: flex;
  margin-right: 32px;
  cursor: pointer;
}
.file-item p {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
.selected-files {
  max-width: 100%;
  overflow-x: auto;
}
</style>